<div ngMenu #menu="ngMenu" (itemSelected)="onItemSelected($event)">
    <ng-template ngMenuContent>
        @if (!IsNullOrUndefined(headerTemplate())) {
            <div class="header" role="presentation">
                <ng-container [ngTemplateOutlet]="headerTemplate()!" />
            </div>

            <div role="separator" aria-orientation="horizontal" class="separator"></div>
        }

        @for (action of actions(); track $index) {
            @if (action.separatorBefore && !$first) {
                <div role="separator" aria-orientation="horizontal" class="separator"></div>
            }

            @if (hasSubmenu(action)) {
                <div
                    ngMenuItem
                    #submenuItem
                    [value]="action.value"
                    [disabled]="action.disabled ?? false"
                    [submenu]="getSubmenu(action)"
                    [class]="action.class ?? ''"
                >
                    @if (!IsNullOrUndefined(action.icon)) {
                        <mat-icon class="icon" [svgIcon]="action.icon!" aria-hidden="true" />
                    }
                    <span class="label">{{ action.label }}</span>
                    <mat-icon class="arrow" [svgIcon]="ICON.caretRight" aria-hidden="true" />
                </div>

                <ng-template
                    [cdkConnectedOverlayOpen]="menu.visible()"
                    [cdkConnectedOverlay]="{ origin: submenuItem, usePopover: 'inline' }"
                    [cdkConnectedOverlayPositions]="[
                        { originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top', offsetX: 6 },
                    ]"
                    cdkAttachPopoverAsChild
                >
                    <immo-menu-panel [actions]="action.children" (actionSelected)="onItemSelected($event)" />
                </ng-template>
            } @else {
                <div
                    ngMenuItem
                    [value]="action.value"
                    [disabled]="action.disabled ?? false"
                    [class]="action.class ?? ''"
                >
                    @if (!IsNullOrUndefined(action.icon)) {
                        <mat-icon class="icon" [svgIcon]="action.icon!" aria-hidden="true" />
                    }
                    <span class="label">{{ action.label }}</span>
                </div>
            }
        }
    </ng-template>
</div>
